import React from 'react';
import { ProgressBar } from '../ProgressBar';
import './CreateJobUploading.scss';
import { CreateJobState } from '../../store/state/createJobState';

export default function CreateJobUploading(props: Props) {
	const status = props.createJobState.createRequestStatus;
	const isComplete = status === 'complete' || status === 'finishing';
	
	return (
		<React.Fragment>
			<div className="page-container">
				<h1 className="h1-mb-1 text-center">Uploading your call logs...</h1>

				<div className="mb-7 text-center text-green">
					Don’t close your browser or navigate away from this page
				</div>

				<div className="create-job-uploading__progress">
					<ProgressBar estimatedDuration={2000} isComplete={isComplete} />
				</div>
			</div>
		</React.Fragment>
	);
}

interface Props {
    createJobState: CreateJobState;
}
